//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "mt-steps",
  props: {
    iconClass: {
      type: String,
      default: ""
    },
    title: String,
    description: String,
    direction: {
      type: String,
      default: "horizontal"
    },
    paddingLeft: {
      type: Number,
      default: 150
    }
  },
  data() {
    return {
      steps: []
    };
  }
};



// WEBPACK FOOTER //
// ./packages/steps/src/steps.vue